import { SIGN_IN_USER_STARTED, SIGN_IN_USER_SUCCESS, SIGN_IN_USER_FAILED, SIGN_OUT_USER, SIGN_IN_TOKEN, GET_STAFF_STARTED, GET_STAFF_SUCCESS, GET_STAFF_FAILED } from "./authConstants";
import { APP_LOADED } from "../async/asyncReducer";
import axios from "axios";

// ROMI-1924 — SSO login (migrated users): redirect to Auth0 via the Laravel broker.
export function signInSSO() {
    return async () => {
        window.location.href = `${process.env.REACT_APP_LARAVEL_URL}auth/redirect?target=front`;
    };
}

// ROMI-1924 — LEGACY password login (hybrid window, for users not yet on SSO).
// Posts credentials to /api/login as a stateful SPA request; the backend
// establishes a cookie session (no token stored in the browser). Audited as legacy_api.
export function signInUser(user) {
    return async (dispatch) => {
        dispatch(signInUserStarted());
        try {
            await axios.get(`${process.env.REACT_APP_LARAVEL_URL}sanctum/csrf-cookie`);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}login`, {
                email: user.email,
                password: user.password,
            });
            dispatch(signInUserSuccess(response.data));
            return "ok";
        } catch (error) {
            dispatch(signInUserFailed(error.response?.data));
            return error.response?.data;
        }
    };
}

export function signInUserStarted() {
    return {
        type: SIGN_IN_USER_STARTED,
        payload: {
            isLoading: true,
        },
    };
}

const signInUserSuccess = (user) => {
    return {
        type: SIGN_IN_USER_SUCCESS,
        payload: {
            user,
        },
    };
};

const signInUserFailed = (error) => {
    return {
        type: SIGN_IN_USER_FAILED,
        payload: {
            error,
        },
    };
};

export function signInToken(user) {
    return (dispatch) => {
        dispatch({
            type: SIGN_IN_TOKEN,
            payload: user,
        });
    };
}

export function verifyAuth() {
    // ROMI-1924 — on boot, prime CSRF + hydrate the user from the cookie session.
    return async function (dispatch) {
        try {
            await axios.get(`${process.env.REACT_APP_LARAVEL_URL}sanctum/csrf-cookie`);
            const res = await axios.get(`${process.env.REACT_APP_API_URL}me`);
            dispatch({
                type: SIGN_IN_USER_SUCCESS,
                payload: { user: { user: res.data.user, token: null, permissions: res.data.permissions, login_method: res.data.login_method } },
            });
        } catch (e) {
            // No valid session — ensure we're in a clean signed-out state.
            dispatch({ type: SIGN_OUT_USER });
        } finally {
            dispatch({ type: APP_LOADED });
        }
    };
}

export function signOutUser() {
    // ROMI-1924 — clear local state then end the Laravel + Auth0 SSO session.
    return (dispatch) => {
        localStorage.removeItem("token"); // clear any legacy token
        dispatch({ type: SIGN_OUT_USER });
        window.location.href = `${process.env.REACT_APP_LARAVEL_URL}auth/logout`;
    };
}

export const getStaff = () => {
    return (dispatch) => {
        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}staff`,
        })
            .then((response) => {
                dispatch(getStaffSuccess(response.data));
            })
            .catch((error) => {
                dispatch(getStaffFailed(error.data));
            });
    };
};

export function getStaffStarted() {
    return {
        type: GET_STAFF_STARTED,
        payload: {
            isLoading: true,
        },
    };
}

const getStaffSuccess = (staff) => {
    return {
        type: GET_STAFF_SUCCESS,
        payload: {
            staff,
        },
    };
};

const getStaffFailed = (error) => {
    return {
        type: GET_STAFF_FAILED,
        payload: {
            error,
        },
    };
};
